import getConfig from 'next/config';
import bog from 'bog';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import RavenJS from 'raven-js';

import { mapStateToProps } from '../utils/withI18n';
import Layout from '../layout';

const StyledError = styled.div`
  align-items: center;
  background: #fff;
  color: #000;
  display: flex;
  flex-direction: column;
  font-size: 22px;
  height: 100vh;
  justify-content: center;
`;

const {
  publicRuntimeConfig: {
    sentryDsn: SENTRY_DSN,
    commit: COMMIT,
    buildId: BUILD_ID,
  },
} = getConfig();

export default
@connect(mapStateToProps)
class ErrorPage extends Component {
  static propTypes = {
    i18n: PropTypes.object,
    locale: PropTypes.string,
    statusCode: PropTypes.number,
  }

  static defaultProps = {
    i18n: {},
    locale: 'en',
    statusCode: -1,
  }

  static async getInitialProps({
    isServer, req, res, err,
  }) {
    // eslint-disable-next-line
    const statusCode = res ? res.statusCode : (err ? err.statusCode : null);
    const props = { statusCode, err };

    if (statusCode === 404) { // ignore 404
      return props;
    }

    bog.error('User hit _error page, isServer=',
      isServer, statusCode, req.url, err, new Error().stack, err && err.stack ? err.stack : '');

    const ravenConfig = {
      release: COMMIT,
      tags: { BUILD_ID, COMMIT },
      environment: typeof window !== 'undefined' ? window.location.host : req.get('host'),
      debug: !!__DEV__,
    };

    // log error to sentry (server side)
    if (isServer && req && err) {
      const __DEV__ = process.env.NODE_ENV !== 'production';
      if (!__DEV__) {
        // https://github.com/zeit/next.js/issues/1852
        // eslint-disable-next-line global-require
        try {
          const Raven = require('raven');
          Raven.config(SENTRY_DSN, ravenConfig).install();
          Raven.captureException(err, { extra: err && err.stack });
        } catch (_err) {
          // nothing
        }
      }
    }

    // log error to sentry (client side)
    if (!__DEV__ && !isServer && !statusCode && err) {
      RavenJS.config(SENTRY_DSN, ravenConfig).install();
      RavenJS.captureException(err, { extra: err && err.stack });
      bog.error('Error page!', err);
    }

    // cheeky reload if statusCode is not set.
    if (!isServer && !statusCode && !err) window.location.reload();

    return props;
  }

  render() {
    const { i18n, locale, statusCode } = this.props;
    return (
      <Layout
        locale={locale}
        omitHeader={true}
        omitFooter={true}
        omitHeaderLangSelect={true}
        omitAllowCookies={true}
      >
        <StyledError>
          {statusCode > -1 ? <h1>{statusCode}</h1> : null}
          <br />
          {i18n['Error!'] || 'Sorry, this page could not be displayed' }
        </StyledError>
      </Layout>
    );
  }
}
